define.alias("shared/components/shared/post/media/side-library", "calendar/components/shared/post/media/side-library");